<template>
  <section class="viewsrhqyBasicManage_autoCallingSchedule p-4 space-y-4">
    <viewTitle
      title="业务管理 / 基础数据管理 / 自动叫号时间维护"
      :showReturn="false"
    />
    <div class="auto-calling-config-bar">
      <div class="auto-calling-config-item frequency-item">
        <span class="config-label">自动叫号执行频率</span>
        <div class="frequency-edit-area">
          <el-input-number
            v-model="frequencyForm.frequency_value"
            :min="1"
            :max="59"
            :controls="false"
            :disabled="frequencyInputDisabled"
            class="frequency-value"
          ></el-input-number>
          <el-select
            v-model="frequencyForm.frequency_unit"
            :disabled="frequencyInputDisabled"
            class="frequency-unit"
          >
<!--            <el-option label="秒" value="second"></el-option>-->
            <el-option label="分钟" value="minute"></el-option>
          </el-select>
          <el-button
            type="primary"
            :loading="frequencyLoading"
            :disabled="frequencyInputDisabled"
            @click="saveAutoCallingFrequencyConfig"
          >
            保存频率
          </el-button>
        </div>
        <div class="frequency-display-area">
          <div class="frequency-field frequency-field-cron">
            <span class="frequency-field-label">cron</span>
            <span class="frequency-field-value">{{
              frequencyForm.cron_expression || "--"
            }}</span>
          </div>
        </div>
      </div>
      <div class="auto-calling-config-item switch-item">
        <span class="config-label">自动叫号总开关</span>
        <span class="switch-status">
          {{ Number(autoCallingEnabled) === 1 ? "已开启" : "已关闭" }}
        </span>
        <el-switch
          v-model="autoCallingEnabled"
          :active-value="1"
          :inactive-value="0"
          :disabled="switchLoading || !canManageSwitch"
          @change="changeAutoCallingSwitch"
        ></el-switch>
      </div>
    </div>
    <div class="space-x-2">
      <el-button
        size="medium"
        type="primary"
        :disabled="!canAddAutoCallingSchedule"
        @click="openDialog()"
      >
        新增
      </el-button>
      <el-button
        size="medium"
        :disabled="!canImportAutoCallingSchedule"
        @click="showImport = true"
      >导入</el-button>
      <el-button
        size="medium"
        :disabled="!canBatchUpdateAutoCallingSchedule"
        @click="openBatchModifyImport"
      >批量修改</el-button>
      <el-button
        size="medium"
        :disabled="!canDeleteAutoCallingSchedule"
        @click="onDelete"
      >删除</el-button>
    </div>
    <div class="space-x-4 text-sm">
      <span>车辆业务类型</span>
      <el-input
        v-model.trim="queryParam.car_business_keyword"
        clearable
        placeholder="请输入车辆业务类型，按值%模糊匹配"
        class="w-60"
      ></el-input>
      <span>生效日期</span>
      <el-date-picker
        v-model="queryDateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        class="w-80"
      ></el-date-picker>
      <span>
        <el-button @click="onSearch" size="small" type="primary">
          刷新数据
        </el-button>
        <el-button @click="onReset" size="small">重置</el-button>
      </span>
    </div>
    <div class="text-xs text-gray-500">
      未单独维护的日期，将自动沿用最近一次已维护生效日期的时间段配置。
    </div>
    <c-table
      isSelection
      :selection.sync="rowKeySelection"
      :isIndex="false"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      @loadPage="loadData"
    >
      <template slot="car_business_name" slot-scope="{ row }">
        <div class="business-name-cell">
          <div
            v-for="(name, index) in row.car_business_names || []"
            :key="`${row.id || 'schedule'}-${index}`"
            class="business-name-line"
          >
            <template v-if="name">
              <span
                v-if="highlightBusinessParts(name).matched"
                class="business-name-highlight"
              >
                {{ highlightBusinessParts(name).matched }}
              </span>
              <span>{{ highlightBusinessParts(name).rest }}</span>
            </template>
            <template v-else>--</template>
          </div>
          <div
            v-if="!(row.car_business_names && row.car_business_names.length)"
            class="business-name-line"
          >
            <template v-if="row.car_business_name">
              <span
                v-if="highlightBusinessParts(row.car_business_name).matched"
                class="business-name-highlight"
              >
                {{ highlightBusinessParts(row.car_business_name).matched }}
              </span>
              <span>{{ highlightBusinessParts(row.car_business_name).rest }}</span>
            </template>
            <template v-else>--</template>
          </div>
        </div>
      </template>
      <template slot="update_time" slot-scope="{ row }">
        {{ row.update_time | timeFormat }}
      </template>
      <template slot="action" slot-scope="{ row }">
        <el-row type="flex" justify="space-around" align="middle">
          <c-link
            :disabled="!canUpdateAutoCallingSchedule"
            @click="openDialog(row)"
            label="修改"
          ></c-link>
          <c-link
            :disabled="!canDeleteAutoCallingSchedule"
            @click="onDelete(row, 1)"
            label="删除"
            type="danger"
          ></c-link>
        </el-row>
      </template>
    </c-table>
    <c-import
      v-bind="importOptions"
      :show.sync="showImport"
      @finish="loadData"
    >
      <span slot="desc">
        <span>
          3、一条数据如果包含多组车辆业务类型，请在同一个单元格内使用
          `/` 分隔填写，例如：业务类型A/业务类型B。
        </span>
        <br />
        <span>
          4、多个业务类型之间的 `/` 两边不要有空格，页面展示时会按业务类型分行识别。
        </span>
        <br />
        <span>
          5、批量导出文件可直接修改后重新导入，系统会忽略“生效日期”的修改并按标识更新原数据。
        </span>
      </span>
    </c-import>
    <c-import
      v-bind="batchModifyImportOptions"
      :show.sync="showBatchModifyImport"
      @finish="loadData"
    >
      <span slot="desc">
        <span>3、请先下载当前勾选数据，再在下载文件基础上修改后导入。</span>
        <br />
        <span>4、批量修改文件只能通过当前“批量修改”入口导入，普通导入入口不支持。</span>
        <br />
        <span>5、系统会忽略“生效日期”的修改，并继续沿用原数据的生效日期进行校验和更新。</span>
      </span>
    </c-import>

    <el-dialog
      :title="form.id ? '编辑自动叫号时间' : '新增自动叫号时间'"
      :visible.sync="dialogVisible"
      width="600px"
      @close="resetForm"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="生效日期" prop="call_date">
          <el-date-picker
            v-model="form.call_date"
            type="date"
            placeholder="请选择生效日期"
            value-format="yyyy-MM-dd"
            :disabled="Boolean(form.id)"
            class="w-full"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="车辆业务类型" prop="car_business_ids">
          <el-select
            v-model="form.car_business_ids"
            multiple
            collapse-tags
            filterable
            remote
            reserve-keyword
            :remote-method="remoteSearchBusinessOptions"
            :loading="businessOptionsLoading"
            @visible-change="onBusinessSelectVisibleChange"
            placeholder="请选择车辆业务类型，支持按值%模糊匹配"
            class="w-full"
          >
            <el-option
              v-for="item in businessOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="叫号开始时间" prop="start_time">
          <el-time-picker
            v-model="form.start_time"
            value-format="HH:mm:ss"
            placeholder="请选择开始时间"
            class="w-full"
          ></el-time-picker>
        </el-form-item>
        <el-form-item label="叫号结束时间" prop="end_time">
          <el-time-picker
            v-model="form.end_time"
            value-format="HH:mm:ss"
            placeholder="请选择结束时间"
            class="w-full"
          ></el-time-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="!canSaveSchedule"
          @click="onSave"
        >保 存</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";

const defaultForm = () => ({
  id: "",
  call_date: "",
  car_business_ids: [],
  start_time: "",
  end_time: ""
});

export default {
  data() {
    return {
      showImport: false,
      showBatchModifyImport: false,
      dialogVisible: false,
      businessOptions: [],
      allBusinessOptions: [],
      businessOptionsLoading: false,
      autoCallingEnabled: 1,
      switchLoading: false,
      frequencyLoading: false,
      frequencyForm: {
        frequency_value: 5,
        frequency_unit: "second",
        cron_expression: "*/5 * * * * *"
      },
      queryDateRange: [],
      queryParam: {
        car_business_keyword: ""
      },
      columns: [
        { label: "生效日期", prop: "call_date_text", width: 120 },
        { label: "车辆业务类型", prop: "car_business_name", minWidth: 180 },
        { label: "叫号开始时间", prop: "start_time", width: 120 },
        { label: "叫号结束时间", prop: "end_time", width: 120 },
        { label: "最后修改人", prop: "update_name", width: 120 },
        { label: "最后修改时间", prop: "update_time", width: 180 },
        { label: "操作", prop: "action", width: 140 }
      ],
      importOptions: {
        title: "文件上传",
        downloadDemoName: "自动叫号时间维护导入模板",
        templateUrl:
          "/api/queue/admin/download_auto_calling_schedule_import_template",
        uploadUrl: "/api/media/upload",
        importUrl: "/api/queue/admin/import_auto_calling_schedule",
        progressUrl: "/api/queue/admin/get_imexport_progress"
      },
      batchModifyImportOptions: {
        title: "批量修改",
        downloadDemoName: "自动叫号时间维护批量数据",
        templateUrl: "",
        uploadUrl: "/api/media/upload",
        importUrl: "/api/queue/admin/import_auto_calling_schedule_batch_update",
        progressUrl: "/api/queue/admin/get_imexport_progress"
      },
      fetchDataEvent: params =>
        this.$common.http({
          url: "/api/queue/admin/query_auto_calling_schedule",
          data: {
            ...params,
            car_business_keyword: this.queryParam.car_business_keyword || "",
            call_date_start: this.queryDateRange[0] || "",
            call_date_end: this.queryDateRange[1] || ""
          }
        }),
      deleteConfig: {
        title: "删除",
        content: "确认删除自动叫号时间配置？删除后数据将不可恢复！",
        url: "/api/queue/admin/delete_auto_calling_schedule"
      },
      form: defaultForm(),
      rules: {
        call_date: [
          { required: true, message: "请选择生效日期", trigger: "change" }
        ],
        car_business_ids: [
          { required: true, message: "请选择车辆业务类型", trigger: "change" }
        ],
        start_time: [
          { required: true, message: "请选择开始时间", trigger: "change" }
        ],
        end_time: [
          { required: true, message: "请选择结束时间", trigger: "change" }
        ]
      }
    };
  },
  computed: {
    permissionKeys() {
      return (((this.$store || {}).state || {}).privilegeConfig || {}).keys || [];
    },
    canSaveFrequency() {
      return this.hasAnyPermission("c-base-mp-auto-calling-schedule-saveFrequency");
    },
    canManageSwitch() {
      return this.hasAnyPermission("c-base-mp-auto-calling-schedule-switch");
    },
    canAddAutoCallingSchedule() {
      return this.hasAnyPermission("c-base-mp-auto-calling-schedule-add");
    },
    canImportAutoCallingSchedule() {
      return this.hasAnyPermission("c-base-mp-auto-calling-schedule-import");
    },
    canBatchUpdateAutoCallingSchedule() {
      return this.hasAnyPermission("c-base-mp-auto-calling-schedule-batchUpdate");
    },
    canDeleteAutoCallingSchedule() {
      return this.hasAnyPermission("c-base-mp-auto-calling-schedule-delete");
    },
    canUpdateAutoCallingSchedule() {
      return this.hasAnyPermission("c-base-mp-auto-calling-schedule-update");
    },
    canSaveSchedule() {
      return this.form.id
        ? this.canUpdateAutoCallingSchedule
        : this.canAddAutoCallingSchedule;
    },
    frequencyInputDisabled() {
      return !this.canSaveFrequency || this.frequencyLoading;
    }
  },
  created() {
    this.loadBusinessOptions();
    this.loadAutoCallingFrequencyConfig();
    this.loadAutoCallingSwitch();
  },
  mixins: [initListMinxin, mixinTableLyout],
  methods: {
    hasAnyPermission(permission) {
      const permissions = Array.isArray(permission) ? permission : [permission];
      return permissions.some(item => this.permissionKeys.includes(item));
    },
    async loadAutoCallingSwitch() {
      const dataObj = await this.$common.http({
        url: "/api/queue/admin/query_auto_calling_switch",
        data: {}
      });
      this.autoCallingEnabled = Number(
        dataObj.data &&
          dataObj.data.data &&
          dataObj.data.data.value !== undefined
          ? dataObj.data.data.value
          : 1
      );
    },
    async changeAutoCallingSwitch(val) {
      const previous = Number(val) === 1 ? 0 : 1;
      this.switchLoading = true;
      try {
        await this.$common.http({
          url: "/api/queue/admin/save_auto_calling_switch",
          data: {
            value: val
          }
        });
        this.$common.pcToastSuccess(
          Number(val) === 1
            ? "自动叫号已开启"
            : "自动叫号已关闭，请改用人工叫号"
        );
      } catch (error) {
        this.autoCallingEnabled = previous;
        throw error;
      } finally {
        this.switchLoading = false;
      }
    },
    async loadAutoCallingFrequencyConfig() {
      const dataObj = await this.$common.http({
        url: "/api/queue/admin/query_auto_calling_frequency_config",
        data: {}
      });
      const config = (dataObj.data && dataObj.data.data) || {};
      this.frequencyForm = {
        frequency_value: Number(config.frequency_value || 5),
        frequency_unit: config.frequency_unit || "second",
        cron_expression: config.cron_expression || "*/5 * * * * *"
      };
    },
    async saveAutoCallingFrequencyConfig() {
      const frequencyValue = Number(this.frequencyForm.frequency_value || 0);
      if (
        !Number.isInteger(frequencyValue) ||
        frequencyValue < 1 ||
        frequencyValue > 59
      ) {
        this.$message.warning("自动叫号执行频率仅支持 1-59");
        return;
      }
      this.frequencyLoading = true;
      try {
        const dataObj = await this.$common.http({
          url: "/api/queue/admin/save_auto_calling_frequency_config",
          data: {
            frequency_value: frequencyValue,
            frequency_unit: this.frequencyForm.frequency_unit
          }
        });
        const config = (dataObj.data && dataObj.data.data) || {};
        this.frequencyForm = {
          frequency_value: Number(config.frequency_value || frequencyValue),
          frequency_unit:
            config.frequency_unit || this.frequencyForm.frequency_unit,
          cron_expression:
            config.cron_expression || this.frequencyForm.cron_expression
        };
        this.$common.pcToastSuccess("自动叫号执行频率保存成功");
      } catch (error) {
        this.$common.pcToastFail(error);
      } finally {
        this.frequencyLoading = false;
      }
    },
    async loadBusinessOptions() {
      this.businessOptionsLoading = true;
      try {
        const dataObj = await this.$common.http({
          url: "/api/queue/admin/query_business_with_child",
          data: {
            state: 1
          }
        });
        const groups = (dataObj.data && dataObj.data.data) || [];
        const options = [];
        (Array.isArray(groups) ? groups : []).forEach(group => {
          const children = Array.isArray(group.children) ? group.children : [];
          if (children.length > 0) {
            children.forEach(child => {
              options.push({
                id: child.id,
                name:
                  group.name && group.name !== child.name
                    ? `${group.name} / ${child.name}`
                    : child.name,
                simple_name: child.name || ""
              });
            });
            return;
          }
          if (group && group.id) {
            options.push({
              id: group.id,
              name: group.name,
              simple_name: group.name || ""
            });
          }
        });
        this.allBusinessOptions = options;
        this.businessOptions = this.mergeSelectedBusinessOptions(options);
      } finally {
        this.businessOptionsLoading = false;
      }
    },
    mergeSelectedBusinessOptions(options) {
      const result = [];
      const optionMap = {};
      const currentOptions = Array.isArray(options) ? options : [];
      const selectedIds = Array.isArray(this.form.car_business_ids)
        ? this.form.car_business_ids
        : [];
      [...selectedIds, ...currentOptions.map(item => item.id)].forEach(id => {
        const option =
          currentOptions.find(item => item.id === id) ||
          this.allBusinessOptions.find(item => item.id === id);
        if (option && !optionMap[option.id]) {
          optionMap[option.id] = true;
          result.push(option);
        }
      });
      return result;
    },
    remoteSearchBusinessOptions(keyword = "") {
      const normalizedKeyword = String(keyword || "").trim();
      if (!normalizedKeyword) {
        this.businessOptions = this.mergeSelectedBusinessOptions(
          this.allBusinessOptions
        );
        return;
      }
      const filteredOptions = this.allBusinessOptions.filter(item => {
        const displayName = String(item.name || "");
        const simpleName = String(item.simple_name || "");
        return (
          displayName.startsWith(normalizedKeyword) ||
          simpleName.startsWith(normalizedKeyword)
        );
      });
      this.businessOptions = this.mergeSelectedBusinessOptions(filteredOptions);
    },
    onBusinessSelectVisibleChange(visible) {
      if (visible) {
        this.remoteSearchBusinessOptions("");
      }
    },
    openDialog(row) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        const form = defaultForm();
        if (row) {
          Object.assign(form, {
            id: row.id || "",
            call_date: row.call_date_text || this.formatCallDate(row.call_date),
            car_business_ids: Array.isArray(row.car_business_ids)
              ? row.car_business_ids
              : row.car_business_id
              ? [row.car_business_id]
              : [],
            start_time: row.start_time || "",
            end_time: row.end_time || ""
          });
        }
        this.form = form;
        this.businessOptions = this.mergeSelectedBusinessOptions(
          this.allBusinessOptions
        );
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    resetForm() {
      this.form = defaultForm();
      this.businessOptions = this.mergeSelectedBusinessOptions(
        this.allBusinessOptions
      );
      this.$refs.form && this.$refs.form.clearValidate();
    },
    formatCallDate(value) {
      const text = String(value || "");
      if (text.length !== 8) {
        return "";
      }
      return `${text.slice(0, 4)}-${text.slice(4, 6)}-${text.slice(6, 8)}`;
    },
    highlightBusinessParts(name) {
      const keyword = (this.queryParam.car_business_keyword || "").trim();
      const text = String(name || "");
      if (!keyword || !text.startsWith(keyword)) {
        return {
          matched: "",
          rest: text
        };
      }
      return {
        matched: keyword,
        rest: text.slice(keyword.length)
      };
    },
    onReset() {
      this.pagintion.page = 1;
      this.rowKeySelection = [];
      this.queryDateRange = [];
      this.queryParam = {
        car_business_keyword: ""
      };
      this.loadData();
    },
    openBatchModifyImport() {
      const ids = Array.isArray(this.rowKeySelection) ? this.rowKeySelection : [];
      if (!ids.length) {
        this.$message.warning("请先选择需要批量修改的数据");
        return;
      }
      this.batchModifyImportOptions = {
        ...this.batchModifyImportOptions,
        templateUrl:
          "/api/queue/admin/download_auto_calling_schedule_batch_export?ids=" +
          encodeURIComponent(ids.join(","))
      };
      this.showBatchModifyImport = true;
    },
    onSave() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return;
        }
        if (this.form.start_time >= this.form.end_time) {
          this.$message.warning("开始时间必须早于结束时间");
          return;
        }
        this.$confirm("确认保存自动叫号时间配置？", "提示").then(async () => {
          try {
            await this.$common.http({
              url: "/api/queue/admin/save_auto_calling_schedule",
              data: { ...this.form }
            });
            this.$common.pcToastSuccess("保存成功");
            this.dialogVisible = false;
            this.loadData();
          } catch (error) {
            this.$common.pcToastFail(error);
          }
        });
      });
    }
  }
};
</script>
<style lang="less" scoped>
.auto-calling-config-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.auto-calling-config-item {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 32px;
}

.frequency-item {
  flex: 1;
  justify-content: flex-start;
  gap: 16px;
}

.switch-item {
  flex-shrink: 0;
  margin-left: auto;
}

.config-label {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.frequency-edit-area {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.frequency-display-area {
  display: flex;
  align-items: stretch;
  gap: 0;
  min-height: 40px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
}

.frequency-value {
  width: 120px;
}

.frequency-unit {
  width: 120px;
}

.frequency-field {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 180px;
  padding: 0 14px;
  background: #fff;
}

.frequency-field-label {
  font-size: 12px;
  color: #909399;
  line-height: 18px;
}

.frequency-field-value {
  font-size: 12px;
  color: #606266;
  line-height: 18px;
  margin-top: 2px;
}

.frequency-field-cron {
  min-width: 180px;
}

.switch-status {
  font-size: 13px;
  color: #409eff;
}

.business-name-cell {
  white-space: normal;
  line-height: 20px;
}

.business-name-line + .business-name-line {
  margin-top: 4px;
}

.business-name-highlight {
  color: #f56c6c;
}
</style>

